import createVanilla, { StoreApi } from "zustand/vanilla";
import { HttpRequestError } from "client/Api/httpClient";
import create, { UseStore } from "zustand";
import { useMemo } from "react";

export type HttpErrorStatusCode = 403 | 404 | 500;

export type HttpErrorData = {
	statusCode: HttpErrorStatusCode;
};

type GlobalErrorStoreData = {
	httpError: HttpErrorData | null;
	setHttpError(httpError: HttpErrorData | null): void;
};

const globalErrorStore: StoreApi<GlobalErrorStoreData> = createVanilla<GlobalErrorStoreData>(
	(set) => {
		return {
			httpError: null,
			setHttpError(httpError: HttpErrorData | null): void {
				set({ httpError });
			}
		};
	}
);

const useGlobalErrorStore: UseStore<GlobalErrorStoreData> = create(globalErrorStore);

export function useGlobalError(): HttpErrorData | null {
	const httpError: HttpErrorData | null = useGlobalErrorStore(x => x.httpError);

	return useMemo(
		() => httpError,
		[httpError]
	);
}

export function handlePageDataLoadingError(error: unknown): never {
	if (!(error instanceof HttpRequestError)) {
		throw error;
	}

	const {
		statusCode
	} = error;

	switch (statusCode) {
		case 403:
		case 404:
		case 500:
			globalErrorStore.getState()
				.setHttpError({
					statusCode: statusCode
				});
			break;
		default:
			break;
	}

	throw error;
}

export function setHttpError(errorData: HttpErrorData): void {
	globalErrorStore.getState()
		.setHttpError(errorData);
}

// This function must be used only in one place of the
// app to clean the error state when URL is changed
// NOTE: You should NOT set error in effect of the component
// and then clear it in the effect's clean up function.
// The reason is that error page is rendered instead of the entire page, which potentially causes
// component which set the error to unmount and call clean up function of its effects.
// So if you unset error in effect's clean up it will also clear the error and cause an endless
// refresh loop.
export function resetHttpError(): void {
	globalErrorStore.getState()
		.setHttpError(null);
}